import { React, useRef } from 'react';
import Sidebar from './sidebar';
import FooterStyle from './footer';
import { ExpandingCards } from './carddesign';
import { animateScroll as scroll } from 'react-scroll';
import { Link } from 'react-router-dom';


export const HomePage = () => {

  const aboutSection = useRef(null);

  const scrollTo = () => {
    scroll.scrollTo(aboutSection.current.offsetTop, {
      duration: 1000,
      smooth: true,
    });
  };

  const cardsData = [
    {
      id: 1,
      // imageSrc: `${process.env.PUBLIC_URL}/images/pexels-startup-stock-photos-7375.jpg`,
      imageSrc: `${process.env.PUBLIC_URL}/images/CMIS.jpg`,
      title: 'Who Are We',
      link: '/aboutus'
    },
    {
      id: 2,
      imageSrc: `${process.env.PUBLIC_URL}/images/RESORTS/bespoke.jpg`,
      title: 'Properties',
      link:'/properties'
    },
    {
      id: 3,
      imageSrc: `${process.env.PUBLIC_URL}/images/RESORTS/Gayana-Marine-Resort.jpg`,
      title: 'Awards & Recognition',
      link:'/awards'
    },
    {
      id: 4,
      imageSrc: `${process.env.PUBLIC_URL}/images/EVENTS/careerpage.jpg`,
      title: 'Career',
      link:'/career'
    },
    {
      id: 5,
      imageSrc: `${process.env.PUBLIC_URL}/images/EVENTS/careerpage4.jpg`,
      title: 'Contact Us',
      link:'/contact'
    }
  ];


  return (
    <div className='top-layout'>
      <div className='Navbar'>
        <Sidebar />
      </div>
    
      <div className='layout'>

        {/* <div style={{ display: 'flex', alignItems: 'left', marginLeft: '1rem' }}>
          <Link to="/" style={{ position:'absolute', cursor: 'pointer', zIndex: '100'}}>
            <img src={process.env.PUBLIC_URL + '/images/KS_logo.png'} alt="Logo" style={{ width: '4.5rem', marginTop:'0.3rem'}} />
          </Link>
        </div> */}

        <div className='backgroundVideo' 
          style={{ 
            position:'absolute', 
            height: '100vh', 
            overflow:'hidden', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            opacity:'1', 
            zIndex:'1',
            maxWidth:'100vw'
            }}>
          <video autoPlay loop muted id='video' style={{ width: '100%', height: 'auto'}}>
            <source src={process.env.PUBLIC_URL + '/videos/intro2.mp4'} type="video/mp4" />
          </video>
          {/* <div className="video-overlay" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgb(31, 56, 110, 0.5)' }}></div> */}
        </div>

        <div className='backgroundImage-home'>
          <img className='image-home' src={process.env.PUBLIC_URL + '/images/KS_logo.png'} alt="headImage" style={{ zIndex:'999'}}/>  
        </div>


        <div className='home-content'>

          <div className='front-text'>
            <h2>Kombinasi Saudagar Sdn Bhd (KSSB) is a leading provider of comprehensive asset management solutions</h2>
          <div className='scroll-button-container'>
            <button 
              onClick={scrollTo} 
              style={{ 
                cursor: 'pointer', 
                padding: '0.4rem 1rem', 
                backgroundColor: '#ffba03', 
                border: 'none', 
                fontSize: '1rem',
                }}>
              Enter
            </button>
          </div>  
          </div>

          
          


          <div className='home-content2' style={{ display:'flex', flexDirection:'row', alignItems:'flex-start', justifyContent:'center', padding:'2rem', height:'40vh'}} ref={aboutSection}>
            <div className='home-content2-2' style={{ width:'50%', height:'100%', overflow:'hidden', padding:'0 1rem', display:'flex', flexDirection:'column', lineHeight:'2rem'}}>
            <h2 style={{ color:'#ffba03'}}>A Leading Expert in Comprehensive Asset Management Solutions</h2>
            <p>
              Kombinasi Saudagar Sdn Bhd (KSSB) is a leading provider of comprehensive asset management solutions, specializing in the care and 
              maintenance of high-value assets, particularly buildings.
              <br />
              <br />
              With extensive experience, we have consistently met the diverse needs of our esteemed local and international clients. Our 
              track record reflects our commitment to excellence and dedication to exceeding client expectations.
            </p>
            <a href='./images/kssb_corporate_profile.pdf' target="_blank" rel="noopener noreferrer" style={{ color:'red'}}>View Corporate Profile</a>
          </div>
          <div  className='home-content2-2-image'>
            <img src={process.env.PUBLIC_URL + '/images/EVENTS/IMG_9222.jpg'} alt="headImage" style={{ width: '100%' }} />
          </div>
          </div>


          <div style={{ margin:'0 0 0 0'}}>
            <div className='contactwidget'>
            <div>
              <h2>Total Asset Management Solutions Provider</h2>
              <p>Get started today and complete our form to get in touch with us</p>
            </div>
            <div>
              <Link to='/contact'>
                <button>Contact us</button>
              </Link>
            </div>
          </div>
          </div>


          <div className='card-container'>
            <ExpandingCards data={cardsData} />
          </div>


          <div className='home-content3'>
            <div className='home-content3-3'>
              <h2 style={{ color:'#ffba03'}}>Core Business and Technological Integration</h2>
              <p style={{ marginBottom:'0'}}>Kombinasi Saudagar Sdn Bhd specializes in comprehensive facilities management, <br/>catering to a diverse range of properties, including:</p>
              <ul style={{ marginTop:'0'}}>
                <li>Luxury resorts</li>
                <li>Premium hotels</li>
                <li>Commercial buildings</li>
                <li>Residential buildings</li>
                <li>Federal government buildings</li>
              </ul>
              <h4 style={{ marginBottom:'0'}}>Services Managed:</h4>
              <ul style={{ marginTop:'0'}}>
                <li>Hygiene</li>
                <li>Security</li>
                <li>Scheduled maintenance</li>
                <li>Periodic maintenance</li>
                <li>Upgrading and rehabilitation works</li>
              </ul>
              <h4 style={{ marginBottom:'0'}}>IR4.0 Technologies Integrated:</h4>
              <ul style={{ marginTop:'0'}}>
                <li>Design frameworks including 3D modelling</li>
                <li>Workflow integration and implementation with smart device integration</li>
                <li>Operations command centre and IoT hub</li>
                <li>Photo LiDAR scanning and IoT sensor flow for enhanced workflow processes</li>
                <li>Work automation featuring robotic rovers and building artificial intelligence</li>
              </ul>
            </div>
            <div className='home-content3-image'>
              <img src={process.env.PUBLIC_URL + '/images/SCREENSHOT/homepage1.jpg'} alt="headImage" style={{ width: '76%' }} />
            </div>
          </div>

        </div>

        <div className='footer'>
          <FooterStyle />
        </div>

      </div>

      

    </div>
  );
}

export default HomePage;
